import request from '@/utils/request'

export const getMyTaskEvents = (params = {}) =>
  request({
    url: '/api/task-events/my',
    method: 'get',
    params
  })

export const getTaskBadgeCount = (params = {}) =>
  request({
    url: '/api/task-events/badge-count',
    method: 'get',
    params,
    skipAuthRedirect: true
  })

export const completeTaskEvent = (eventId) =>
  request({
    url: `/api/task-events/${eventId}/complete`,
    method: 'post'
  })

export const readTaskEvent = (eventId) =>
  request({
    url: `/api/task-events/${eventId}/read`,
    method: 'post',
    skipAuthRedirect: true
  })

export const getTaskDailySummary = (params = {}) =>
  request({
    url: '/api/task-events/daily-summary',
    method: 'get',
    params
  })

export const readTaskDailySummary = (params = {}) =>
  request({
    url: '/api/task-events/daily-summary/read',
    method: 'post',
    params
  })

export const getTaskGamificationStats = (params = {}) =>
  request({
    url: '/api/task-events/gamification-stats',
    method: 'get',
    params
  })

export const getTaskDailySummaries = (params = {}) =>
  request({
    url: '/api/task-events/daily-summaries',
    method: 'get',
    params
  })

export const generateTaskDailySummaries = () =>
  request({
    url: '/api/task-events/daily-summary/generate',
    method: 'post'
  })

export const readTaskDailySummaryItem = (summaryId) =>
  request({
    url: `/api/task-events/daily-summaries/${summaryId}/read`,
    method: 'post'
  })

export const getTaskUsersOverview = (params = {}) =>
  request({
    url: '/api/task-events/users-overview',
    method: 'get',
    params
  })

export const getTaskMobileBoard = (params = {}) =>
  request({
    url: '/api/task-events/mobile-board',
    method: 'get',
    params
  })

export const getTaskViewScope = () =>
  request({
    url: '/api/task-events/view-scope',
    method: 'get'
  })

export const getTaskViewGrantsMatrix = () =>
  request({
    url: '/api/task-events/view-grants/matrix',
    method: 'get'
  })

export const saveTaskViewGrantsMatrix = (grants) =>
  request({
    url: '/api/task-events/view-grants/matrix',
    method: 'put',
    data: { grants }
  })

export const getInboundNotifyRecipients = () =>
  request({
    url: '/api/task-events/inbound-notify-recipients',
    method: 'get'
  })

/** 新：{ recipients: [{user_id, enabled_type_keys}] }；旧：userIds 数组 + 可选全局类型 */
export const saveInboundNotifyRecipients = (payloadOrUserIds, enabledTypeKeys) => {
  const body =
    payloadOrUserIds && !Array.isArray(payloadOrUserIds)
      ? payloadOrUserIds
      : {
          user_ids: payloadOrUserIds,
          ...(Array.isArray(enabledTypeKeys) ? { enabled_type_keys: enabledTypeKeys } : {})
        }
  return request({
    url: '/api/task-events/inbound-notify-recipients',
    method: 'put',
    data: body
  })
}

export const ackAllInboundNotifyUnread = () =>
  request({
    url: '/api/task-events/inbound-notify/ack-all-unread',
    method: 'post'
  })

export const getSharedTaskAssignees = () =>
  request({
    url: '/api/task-events/shared-task-assignees',
    method: 'get'
  })

export const saveSharedTaskAssignees = (payload) =>
  request({
    url: '/api/task-events/shared-task-assignees',
    method: 'put',
    data: payload
  })

export const reconcilePackagingTasks = () =>
  request({
    url: '/api/task-events/reconcile-packaging',
    method: 'post'
  })

export const getTaskMobileCategories = (userId, params = {}) =>
  request({
    url: `/api/task-events/mobile-board/${userId}/categories`,
    method: 'get',
    params
  })

export const getTaskMobileProcessingSuppliers = (userId, categoryKey) =>
  request({
    url: `/api/task-events/mobile-board/${userId}/categories/${encodeURIComponent(categoryKey)}/suppliers`,
    method: 'get'
  })

export const getTaskMobilePackagingCustomers = (userId, categoryKey) =>
  request({
    url: `/api/task-events/mobile-board/${userId}/categories/${encodeURIComponent(categoryKey)}/customers`,
    method: 'get'
  })

/** 出货临期：时间版块 */
export const getTaskMobileDeliveryBuckets = (userId) =>
  request({
    url: `/api/task-events/mobile-board/${userId}/categories/delivery/buckets`,
    method: 'get'
  })

/** 出货临期：某版块下客户 */
export const getTaskMobileDeliveryCustomers = (userId, params = {}) =>
  request({
    url: `/api/task-events/mobile-board/${userId}/categories/delivery/customers`,
    method: 'get',
    params
  })

/** 出货临期：版块+客户下材料 */
export const getTaskMobileDeliveryMaterials = (userId, params = {}) =>
  request({
    url: `/api/task-events/mobile-board/${userId}/categories/delivery/materials`,
    method: 'get',
    params
  })

export const getTaskMobilePackagingBulkSheet = (userId, categoryKey, customerKey) =>
  request({
    url: `/api/task-events/mobile-board/${userId}/categories/${encodeURIComponent(categoryKey)}/customers/${encodeURIComponent(customerKey)}/packaging-bulk`,
    method: 'get'
  })

export const submitTaskPackagingBulk = (data) =>
  request({
    url: '/api/task-events/packaging-bulk/submit',
    method: 'post',
    data
  })

export const getTaskMobileInternalMaterials = (userId, categoryKey, params = {}) =>
  request({
    url: `/api/task-events/mobile-board/${userId}/categories/${encodeURIComponent(categoryKey)}/materials`,
    method: 'get',
    params
  })

export const getTaskAssignees = () =>
  request({
    url: '/api/task-events/assignees',
    method: 'get'
  })

export const createManualTask = (data) =>
  request({
    url: '/api/task-events/manual',
    method: 'post',
    data
  })

export const getManualTaskKinds = () =>
  request({
    url: '/api/task-events/manual/kinds',
    method: 'get'
  })

export const suggestManualTaskOutputLot = (params) =>
  request({
    url: '/api/task-events/manual/suggest-output-lot',
    method: 'get',
    params
  })

export const getManualTask = (manualTaskId) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}`,
    method: 'get'
  })

export const completeManualTask = (manualTaskId) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/complete`,
    method: 'post'
  })

export const updateManualTask = (manualTaskId, data) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}`,
    method: 'patch',
    data
  })

export const cancelManualTask = (manualTaskId) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/cancel`,
    method: 'post'
  })

export const approveManualTask = (manualTaskId, data = {}) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/approve`,
    method: 'post',
    data
  })

export const rejectManualTask = (manualTaskId, data = {}) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/reject`,
    method: 'post',
    data
  })

export const getManualTaskExecuteContext = (manualTaskId) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/execute-context`,
    method: 'get'
  })

export const executeManualTaskColorFormulation = (manualTaskId, data = {}) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/execute/color-formulation`,
    method: 'post',
    data
  })

export const executeManualTaskMarketProcurement = (manualTaskId, data = {}) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/execute/market-procurement`,
    method: 'post',
    data
  })

export const linkManualTaskPurchase = (manualTaskId, data) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/execute/purchase-link`,
    method: 'post',
    data
  })

export const getManualTaskPlannedOutputLot = (manualTaskId, params) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/planned-output-lot`,
    method: 'get',
    params
  })

export const executeManualTaskProcess = (manualTaskId, data) =>
  request({
    url: `/api/task-events/manual/${manualTaskId}/execute/process`,
    method: 'post',
    data
  })
